cc.Class({
    extends: cc.Component,
    onLoad () { this.layout = this.node.getComponent(cc.Layout); },
    onEnable () { this.layout.updateLayout(); }
});
